import { bootstrapApplication } from '@angular/platform-browser';

import { staffHandlers } from '@amp/testing/mocks/staff';
import { startDevMswWorker } from '@amp/testing/msw/browser';

import { appConfig } from './app/app.config';
import { App } from './app/app.component';

enableMocking()
  .then(() => bootstrapApplication(App, appConfig))
  .catch((err) => console.error(err));

async function enableMocking(): Promise<void> {
  await startDevMswWorker(staffHandlers);
}
